module.exports = __webpack_public_path__ + "img/finland-ischemic-heart-disease-female.bcb96953.png";